import React from 'react'
import { TextStyle } from 'react-native'
import { TextChildren, VoidFunction } from 'lib/types'
import { createStyles, useStyles } from 'lib/styles'
import { BaseText } from './BaseText'

type ErrorProps = {
    numberOfLines?: number,
    onPress?: VoidFunction,
    style?: TextStyle,
    forceColor?: string,
    children?: TextChildren
}

export const Error: React.FunctionComponent<ErrorProps> = ({
    children,
    numberOfLines,
    onPress,
    style = {},
    forceColor
}) => {
    const { styles } = useStyles(stylesheet)

    return (
        <BaseText
            onPress={onPress}
            style={{
                ...styles.text,
                ...style
            }}
            numberOfLines={numberOfLines}
            forceColor={forceColor}
            children={children}
        />
    )
}

const stylesheet = createStyles(theme => ({
    text: {
        ...theme.typography.error,
        color: theme.icon.error,
        fontSize: 12,
        lineHeight: 15
    }
}))
